export default "/images/vendor/flag-icons/flags/1x1/gt.svg?9ac40fe72107a3c09365d2621a1b999d";